import { Brand } from "entities/brands/types";
import {
  Page,
  PageModuleDataWithPageId,
  PageModuleStatus,
} from "entities/pages/types";
import { GamesTableData } from "modules/games/types";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import { InputHookResult } from "shared/hooks/useInputState";
import { ModalHookResult } from "shared/hooks/useModalState";
import { PagesColumnsProps } from "../types";

export enum PagesTabs {
  Preview = "preview",
  Schedule = "schedule",
}

export enum ModulesView {
  List = "list",
  Tiles = "tiles",
}

type ReorderPagesParams = {
  brandId: string;
  pages: Page[];
};

export type PagesPageType = {
  isLoadingPages: boolean;
  brandDetails?: Brand;
  data: Page[];
  gamesList: GamesTableData;
  searchGamesData: {
    onChange: (value: string) => void;
    value: string;
  };
  pageDrawer: DrawerHookResult<string>;
  handleAuthenticatedPage: (pageId: string) => void;
  handleUnauthenticatedPage: (pageId: string) => void;
  columnsParams: PagesColumnsProps;
  mutateReorderPages: (value: ReorderPagesParams) => void;
  deleteDefaultPageModal: ModalHookResult;
  unpublishDefaultPageModal: ModalHookResult;
  regularDeleteModal: ModalHookResult;
  handlePageMaintenanceMode: (pageId: string, value: boolean) => void;
  pageMaintenanceModeModal: ModalHookResult;
  brandMaintenanceModeModal: ModalHookResult;
  brandMaintenanceModeDescription?: InputHookResult;
  pageMaintenanceModeDescription?: InputHookResult;
  handleDeletePage: () => void;
  isLoadingDeletePage: boolean;
  isLoadingPageMaintenanceMode: boolean;
  searchData: {
    value: string;
    onChange: (value: string) => void;
    filteredData: Page[];
    isSearchActive: boolean;
  };
  activeTab: PagesTabs;
  setActiveTab: (tab: PagesTabs) => void;
  searchModulesData: {
    value: string;
    onChange: (value: string) => void;
    filteredData: PageModuleDataWithPageId[];
    isSearchActive: boolean;
  };
  allModulesList: PageModuleDataWithPageId[];
  isLoadingAllModules: boolean;
  onUpdateModuleStatus: (params: {
    status: PageModuleStatus;
    moduleId: string;
    pageId: string;
  }) => void;
};
